import React, { useEffect } from 'react';
import { StepsBannerArrows } from '@PetSureAustralia/petsure-react-ui-library/distLib/components';
import './verification.scss';
import { useSelector } from 'react-redux';
import { useFormContext } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import VerifyCode from '../../components/verifyCode/verifyCode';
import { SLICES } from '../../constants/slices';
import { FORM_KEYS } from '../../constants/formKeys';
import { CSPUrlsMap } from '../../routes/CSPUrlsMap';
import { FAQContent } from '../../components/liveVet/faqContent';
import { FAQ_CODENAME } from '../../constants/cmsCodeName';
import useVerify from './useVerify';
import Loading from '../../components/shared/Loading/Loading';
import useStepupChallenge from '../../hooks/useStepupChallenge';

const VerificationByEmail = () => {
  const { watch } = useFormContext();
  const { stepUpSmsChallenge } = useStepupChallenge();
  const navigate = useNavigate();
  const { tokenClaims } = useSelector((state) => state?.[SLICES.AUTHENTICATION]);
  const {
    getVerifyCode,
    isCodeSent,
    confirmUserEnrollment,
    errorMessage,
    updateUserLoading,
    verifyUserLoading,
    confirmEnrollmentLoading,
    timeLeft,
    isNavigateToSmsVerification,
    setIsNavigateToSmsVerification
  } = useVerify({
    verifyType: 'verify-email',
    verifyTypeInput: tokenClaims?.email,
    verifyCode: watch(FORM_KEYS.VERIFY_EMAIL_CODE)
  });

  useEffect(() => {
    if (tokenClaims?.verificationPendingEmail === false) {
      setIsNavigateToSmsVerification(true);
      stepUpSmsChallenge(`${window.location.origin}${CSPUrlsMap.verifySms.url}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tokenClaims?.verificationPendingEmail, navigate]);

  const steps = [
    { isCompleted: false, isActive: true, label: 'VERIFY EMAIL' },
    { isActive: false, label: 'VERIFY PHONE' }
  ];
  if (updateUserLoading || verifyUserLoading || confirmEnrollmentLoading || isNavigateToSmsVerification) {
    return <Loading />;
  }
  return (
    <>
      <div className="verifiyContainer">
        <StepsBannerArrows steps={steps} />
        <VerifyCode
          type="email"
          typeValue={tokenClaims?.email}
          title="Verify your email"
          handleSendCode={getVerifyCode}
          handleVerifyCode={confirmUserEnrollment}
          isCodeSent={isCodeSent}
          errorMessage={errorMessage}
          timeLeft={timeLeft}
        />
      </div>
      <FAQContent faqCategory={FAQ_CODENAME.VERIFY_EMAIL} />
    </>
  );
};

export default VerificationByEmail;
